import React from 'react';
import { Typography } from '@mui/material';

import { ACCESS_REMOVED_MESSAGE } from '../../utils/jobAccessError';

interface INoAccessMessageProps {
  title?: string;
  message?: string;
}

// Centered "we can't show this listing" panel fed into the existing
// `noAccessComponent` slot on BasicLayout / CardWrapper. Defaults to the 403
// self-service "access removed" copy; callers override title/message to reuse the
// same layout for other states (e.g. a missing or deleted listing).
export const NoAccessMessage = ({
  title = 'Access removed',
  message = ACCESS_REMOVED_MESSAGE,
}: INoAccessMessageProps = {}) => (
  <div
    data-cy="noAccessMessage"
    style={{ maxWidth: 640, margin: '48px auto', padding: 24, textAlign: 'center' }}
  >
    <Typography
      variant="h5"
      gutterBottom
    >
      {title}
    </Typography>
    <Typography variant="subtitle1">
      {message}
    </Typography>
  </div>
);
